import React from 'react';
import ReactDOM from "react-dom";
import CustomerProfile from './customerProfile';
import Invoice from './invoice';
import ItemAdd from './itemAdd';
import UserProfile from './userProfile';
import Loader from './loader';

export default class Items extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            isSubmitting: false,
            //result: null,
            items: [],
            itemID: null
        };
    }

    componentDidMount() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php?event=items-get&userID=' + userID + '&uCompanyID=' + uCompanyID;
        fetch(url, {
            method: "POST",
            //body: JSON.stringify(UserProfile.getUserID, UserProfile.getCompanyID),
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(res => {
                this.setState({ isSubmitting: false });
                return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                    //console.log(result);
                    this.itemsShow(result);
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    invoiceButton() {
        return (
            <div>
                <button className="push" onClick={() => this.itemsCheck()}>
                    {"Számla"}
                </button>
            </div>
        );
    }

    itemDelete(itemID) {
        new ItemAdd().itemDelete(itemID);
    }

    itemsNarrow() {
        new Invoice().narrowRead();
    }

    itemsShow(items) {
        ReactDOM.render(
            <Loader />, document.getElementById('invoiceBody')
        );
        const itemTag = 'item-';
        const priceTag = 'price-';
        var push = null;
        var cData = CustomerProfile.getCustomer();
        var title = <div>
            <h1>
                {cData.name}
            </h1>
            <b>{this.props.name}</b>
        </div>;
        var narrow = <div className='row'>
            <input id='narow' onKeyDown={() => this.itemsNarrow()} type='text' placeholder={'Szűkítés'} />
        </div>;
        const res = items.map((item) =>
            <li className='list' key={item.itemsID}>
                <b>{item.name}</b>{' ' + item.unit + '/' + item.amount}
                <input id={itemTag + item.itemsID} type='checkbox' data={item.name} />
                <p>
                    <b>{'Nettó érték: '}</b>
                    <input id={priceTag + item.itemsID} type='text' defaultValue={item.unitPrice} />
                    <i onClick={() => this.itemDelete(item.itemsID)}>Tétel törlése</i>
                </p>
            </li>
        );
        push = this.invoiceButton();
        setTimeout(function () {
            ReactDOM.render(<div>{title}{narrow}<ul id='list'>{push}{res}</ul></div>, document.getElementById('invoiceBody')
            );
        }, 100);
    }

    itemsCheck() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        const data = { event: 'items-id', userID: userID, uCompanyID: uCompanyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.items = result;
                    this.invoiceSelect(result);
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    invoiceSelect(items) {
        var checked = [];
        var price = [];
        var name = [];
        var iData = [];
        const companyID = CustomerProfile.getCompanyID();
        var i = 0;
        var numberError = false;
        for (i in items) {
            if (document.getElementById('item-' + items[i]['itemsID']).checked === true) {
                checked = items[i]['itemsID'];
                price = document.getElementById("price-" + items[i]['itemsID']).value;
                name = document.getElementById("item-" + items[i]['itemsID']).getAttribute('data');
                iData[i] = { 'itemID': checked, 'price': price, 'name': name };
            }
            if (isNaN(price) === true) {
                numberError = true;
            }
        }
        if (iData.length > 0 && numberError === false) {
            new Invoice().invoiceSelect(iData, companyID);
        } else {
            CustomerProfile.setCompanyID(companyID);
            if (numberError === true) {
                ReactDOM.render(
                    <Items name="A nettó értéke csak szám lehet!" />, document.getElementById('invoiceBody')
                );
            } else {
                ReactDOM.render(
                    <Items name="Nem lett kijelőlve számlázható tétel!" />, document.getElementById('invoiceBody')
                );
            }
        }

    }

    render() {
        return (
            <ul>
            </ul>
        );
    }
}